import { useState } from 'react'

export const Block = ({
    header,
    children,
    className,
    align = 'center',
    collapsible = false,
    defaultOpen = true,
    summary,
}: {
    header: any
    children: any
    className?: string
    /** Header alignment. Defaults to centre for the account screens that
     *  predate this prop; the server cards ask for left throughout. */
    align?: 'center' | 'left'
    /** The header becomes a toggle. Off by default: the fifty-odd blocks
     *  that predate this prop are read, not opened, and a header that
     *  suddenly folds its own content would be a surprise on all of them. */
    collapsible?: boolean
    /** Only read when collapsible. */
    defaultOpen?: boolean
    /** A line shown beside the header while folded, so a closed block still
     *  says what is in it. */
    summary?: any
}) => {
    const [open, setOpen] = useState(!collapsible || defaultOpen)

    const heading = (
        <div
            className={`text-xs uppercase tracking-widest opacity-50 ${align === 'left' ? 'text-left' : 'text-center'}`}
        >
            {header}
        </div>
    )

    return (
        <div
            className={['flex flex-col gap-2 bg-gray-500 bg-opacity-10 rounded p-2 w-full', className]
                .filter(Boolean)
                .join(' ')}
        >
            {collapsible ? (
                <button
                    type='button'
                    onClick={() => setOpen((v) => !v)}
                    className='flex w-full flex-row items-center gap-2 text-left'
                >
                    <span className='w-3 text-xs opacity-40'>{open ? '−' : '+'}</span>
                    {heading}
                    {!open && summary && (
                        <span className='min-w-0 flex-1 truncate text-right text-xs opacity-40'>{summary}</span>
                    )}
                </button>
            ) : (
                heading
            )}
            {open && (
                <div className='w-full overflow-hidden grid grid-cols-[max-content,1fr] justify-start gap-2'>
                    {children}
                </div>
            )}
        </div>
    )
}
